// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import MoveAssignmentToLessonAsyncRequestModel from '../../model/move-assignment-to-lesson-async-request-model';
import MoveAssignmentToLessonAsyncRequestDTO from '../dto/move-assignment-to-lesson-async-request-dto';
import dtoSchema from '../schemas/move-assignment-to-lesson-async-request-schema';

export default abstract class MoveAssignmentToLessonAsyncRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<MoveAssignmentToLessonAsyncRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.lessonId = data.lessonId;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  * @type {int64}
  */
  lessonId?: number;

  static toModel(dto: DeepPartial<MoveAssignmentToLessonAsyncRequestDTO>): MoveAssignmentToLessonAsyncRequestModel;
  static toModel(dto: DeepPartial<MoveAssignmentToLessonAsyncRequestDTO> | undefined | null): MoveAssignmentToLessonAsyncRequestModel | undefined;
  static toModel(dto: DeepPartial<MoveAssignmentToLessonAsyncRequestDTO> | undefined | null): MoveAssignmentToLessonAsyncRequestModel | undefined {
    return dto ? new MoveAssignmentToLessonAsyncRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<MoveAssignmentToLessonAsyncRequestModel> | MoveAssignmentToLessonAsyncRequestModel): MoveAssignmentToLessonAsyncRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      lessonId: unwrapped.lessonId,
    } as MoveAssignmentToLessonAsyncRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for MoveAssignmentToLessonAsyncRequestModel, can not map to MoveAssignmentToLessonAsyncRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
